import React from 'react';
import parse from 'url-parse';
import querystring from 'query-string';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import Button from '@material-ui/core/Button';
import * as Yup from 'yup';
import { InputLabel, Paper, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';
import LabelValueComponent from '../LabelValueComponent';
import { findGrapesJSComponent, getVideoUrlForVideosSection } from '../../utils';
import TextInputField from '../form/TextInputField';

const useStyles = makeStyles((theme) => ({
	boxContent: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.paper,
	},
	descriptionWrapper: {
		paddingBottom: theme.spacing(2),
	},
	eachComponent: {
		width: 300,
		marginBottom: theme.spacing(2.5),
		'& label': {
			marginBottom: theme.spacing(1),
			display: 'block',
		},
	},
	formWrapper: {
		'& .submitButton': {
			textAlign: 'right',
		},
		'& .input-textfield': {
			width: 375,
		},
	},
}));

const EditVideoDialog = (props) => {
	console.log('EditVideoDialog props', props);
	const { open, handleClose, videoContainerId } = props;
	const classes = useStyles();
	// 	const servicesSettings = useStoreState(state => state.template.servicesSettings);
	// const setServicesSettings = useStoreActions(actions => actions.template.setServicesSettings);

	const handleSave = async (values) => {
		console.log('EditVideoDialog handleSave', videoContainerId, values);
		const { videoYoutubeUrl, videoVimeoUrl } = values;
		let fullEmbedUrl;
		let videoId;
		if (videoYoutubeUrl) {
			const parsedUrl = parse(videoYoutubeUrl);
			const { query } = parsedUrl;
			console.log(query);
			if (query.includes('v=')) {
				const parsedQuery = querystring.parse(query);
				console.log(parsedQuery);
				videoId = parsedQuery.v;
			} else {
				videoId = videoYoutubeUrl;
			}

			// Include origin in youtube embed url and test
			fullEmbedUrl = `${process.env.REACT_APP_HTML_EDITOR_URL}/youtube_relay.html?v=${videoId}`;
		} else if (videoVimeoUrl) {
			if (videoVimeoUrl.includes('vimeo.com')) {
				videoId = videoVimeoUrl.substr(videoVimeoUrl.lastIndexOf('/') + 1).trim();
			} else {
				videoId = videoVimeoUrl;
			}
			fullEmbedUrl = `https://player.vimeo.com/video/${videoId}`;
		}
		const videoContainer = findGrapesJSComponent(`${videoContainerId} .video-wrapper`);
		if (videoContainer) {
			// remove all existing video component
			const allVideos = videoContainer.findType('video');
			console.log('EditVideoDialog allVideos', allVideos);
			allVideos.forEach((video) => video.remove());
			// add new iframe component directly
			videoContainer.append({
				tagName: 'iframe',
				attributes: {
					src: fullEmbedUrl,
					frameborder: '0',
					allowfullscreen: 'true',
					referrerpolicy: 'strict-origin-when-cross-origin',
				},
				style: {
					width: '100%',
					height: '100%',
				},
			});
		}

		handleClose && handleClose();
	};

	const { videoYoutubeUrl, videoVimeoUrl } = getVideoUrlForVideosSection(videoContainerId);

	const renderForm = () => {
		return (
			<Form className={classes.formWrapper}>
				<LabelValueComponent
					label={<InputLabel>{`Youtube ${_e('video')} URL`}</InputLabel>}
					value={
						<TextInputField
							name="videoYoutubeUrl"
							placeholder="https://www.youtube.com/watch?v=3y0GnTbAMLU"
							help={`${_e('e_g')} https://www.youtube.com/watch?v=3y0GnTbAMLU`}
						/>
					}
				/>
				<LabelValueComponent
					label={<InputLabel>{`Vimeo ${_e('video')} URL`}</InputLabel>}
					value={
						<TextInputField
							name="videoVimeoUrl"
							placeholder="https://vimeo.com/290833426"
							help={`${_e('e_g')} https://vimeo.com/290833426`}
						/>
					}
				/>
				<Box p={1} pt={2}>
					<div className="submitButton">
						<Button
							id="save-video"
							variant="contained"
							color="primary"
							type="submit"
							// onClick={handleSave}
						>
							{_e('save')}
						</Button>
					</div>
				</Box>
			</Form>
		);
	};

	const renderContent = () => {
		return (
			<div className={`useImageBrowseWrapper`}>
				<Paper elevation={0} className={classes.boxContent}>
					<div className="height05rem" />
					<Formik
						initialValues={{
							videoYoutubeUrl,
							videoVimeoUrl,
						}}
						validationSchema={Yup.object({
							// subdomain: Yup.string()
							//   .max(15, 'Must be 15 characters or less')
							//   .required('Required')
						})}
						onSubmit={async (values, { setSubmitting }) => {
							// showFormikValues(values, setSubmitting);
							await handleSave(values);
							setSubmitting(false);
						}}
					>
						{renderForm}
					</Formik>
				</Paper>
				<Box p={1} />
			</div>
		);
	};
	return (
		<GenericDialog
			shadedContent
			maxWidth="md"
			title={_e('video')}
			subtitle={_e('videos_desc')}
			content={renderContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditVideoDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	// sectionId: PropTypes.string,
	videoContainerId: PropTypes.string,
};

export default EditVideoDialog;
